import { camelizeKeys } from "humps";
import { RHEA_CMS_ACTIVITIES_DASHBOARD_API_ENDPOINT } from "../Constants/API";
import getCustomAxios from "../Helpers/customAxios";

export function getActivitiesDashboard(onSuccessCallback, onErrorCallback) {
  const axios = getCustomAxios();

  axios
    .get(RHEA_CMS_ACTIVITIES_DASHBOARD_API_ENDPOINT)
    .then((successResponse) => {
      const responseData = successResponse.data.data;
      const data = camelizeKeys(responseData);
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    });
}
